import React, { useEffect } from "react";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { NavLink } from "react-router-dom";
import { useRecoilState } from "recoil";
import { navLinks } from "../../../infrastructure/defaults/navLinks";
import { navLinkState } from "../../../infrastructure/states/navLinkState";
import NavbarLinks from "./navbar-links";
import "./style.scss";

const Navbar = (): JSX.Element => {
  const [activeLink, setActiveLink] = useRecoilState(navLinkState);
  const { scroll: S } = useLocomotiveScroll();
  useEffect(() => {
    if (S) {
      S.scrollTo(activeLink.id, { duration: 1200 });
    }
  }, [activeLink, S]);

  return (
    <nav id="navbar" className="section-wrapper">
      <NavbarLinks
        links={navLinks}
        activeLinkIndex={activeLink.index}
        setActiveLink={setActiveLink}
      />
      <NavLink to={"/project/second-projet"}>Project</NavLink>
    </nav>
  );
};

export default Navbar;
